<template>
  <div>
    <provisioning-status @refresh="load" />
    <v-card class="main-card">
      <v-card-title class="screen-title">
        <span>SASEゲートウェイ一覧</span>
        <manual-button path="/sase-gateway-list/" />
      </v-card-title>
      <v-card-text class="pa-2" v-if="isLoaded">
        <div>
          <v-row no-gutters justify="end" class="mb-2">
            <v-btn color="primary" v-permission.admin @click="showRegister"
              >契約追加</v-btn
            >
          </v-row>

          <v-row no-gutters justify="space-between" class="my-2">
            <v-col cols="auto">
              <span>{{ saseGatewayTable.items.length }}件表示</span></v-col
            >
            <!-- VNコネクト設定未完了一覧 -->
            <v-col cols="auto">
              <v-btn
                class="mr-2"
                color="error"
                v-if="saseGatewayResettingResult.saseGatewayTotal > 0"
                v-permission.admin
                @click="showSaseGatewayResetting"
                >VNコネクト設定未完了一覧</v-btn
              >
              <v-btn color="primary" @click="load">一覧更新</v-btn>
            </v-col>
          </v-row>

          <app-table
            primary-key="saseGatewayVnConnectAct.wnumber"
            v-model:table-sort-by="saseGatewayTable.sortBy"
            :fields="saseGatewayTable.fields"
            :items="saseGatewayTable.items"
            :hover="true"
            :td-class="tdClass"
            :tr-class="rowHighlight"
            :per-page="-1"
            @click:row="selectRow"
          />
        </div>

        <!-- 詳細表示エリア -->
        <template v-if="isDetailLoaded && selectedItem">
          <v-card-title class="screen-title mt-4">
            <span
              >SASEゲートウェイ{{
                $filter.enumTo(
                  selectedItem.saseGatewayVnConnectCommon
                    .saseGatewayServiceType,
                  "saseGatewayServiceType"
                )
              }}契約詳細</span
            >
          </v-card-title>
          <v-card-text>
            <v-row no-gutters justify="end" class="mt-2">
              <div class="d-flex ga-1 flex-wrap">
                <v-btn color="primary" v-permission.admin @click="showEdit"
                  >契約変更</v-btn
                >
                <v-btn
                  color="primary"
                  v-permission.config
                  :disabled="isVnConnectEnabled"
                  @click="modifyStatus(true)"
                  >VNコネクト有効</v-btn
                >
                <v-btn
                  color="primary"
                  v-permission.config
                  :disabled="!isVnConnectEnabled"
                  @click="modifyStatus(false)"
                  >VNコネクト無効</v-btn
                >
                <v-btn
                  color="primary"
                  v-permission.admin
                  @click="showDeleteConfirm"
                  >解約</v-btn
                >
              </div>
            </v-row>
            <v-row no-gutters justify="end" class="mt-2">
              <v-btn color="info" v-permission.config @click="openSecurityLink"
                >{{
                  $filter.enumTo(
                    selectedItem.saseGatewayVnConnectCommon
                      .saseGatewayServiceType,
                    "saseGatewayServiceType"
                  )
                }}管理コンソール</v-btn
              >
            </v-row>

            <!-- 基本設定 -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold">基本設定</span>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="タイプ"
                  :value="
                    $filter.enumTo(
                      selectedItem.saseGatewayVnConnectCommon
                        .saseGatewayServiceType,
                      'saseGatewayServiceType'
                    )
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="サービスキー(Act)"
                  :value="detailData.saseGatewayVnConnectAct.serviceKey"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="サービスキー(Sby)"
                  :value="detailData.saseGatewayVnConnectSby.serviceKey"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="品目"
                  :value="
                    detailData.saseGatewayVnConnectCommon.bandwidthType +
                    '(' +
                    $filter.bandwidthTo(
                      detailData.saseGatewayVnConnectCommon.bandwidth
                    ) +
                    ')'
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="ロケーション"
                  :value="
                    $filter.enumTo(
                      detailData.saseGatewayVnConnectCommon.location,
                      'location'
                    )
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="備考"
                  :value="
                    $filter.emptyTo(
                      detailData.saseGatewayVnConnectCommon.description,
                      '-'
                    )
                  "
                />
              </v-col>
            </v-row>

            <!-- 接続先VPN/VN -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold">接続先VPN/VN</span>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="接続先VPN/VNコード"
                  :value="detailData.saseGatewayVnConnectCommon.vpnVnCode"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="仮想ネットワーク(VN)名"
                  :value="
                    detailData.saseGatewayVnConnectCommon.vpnVnCode.startsWith(
                      'B'
                    )
                      ? '-'
                      : detailData.saseGatewayVnConnectCommon.vnName
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="L2/L3"
                  :value="detailData.saseGatewayVnConnectCommon.vnType"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="ルーティング種別"
                  :value="detailData.saseGatewayVnConnectCommon.routingType"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="AS番号"
                  :value="detailData.saseGatewayVnConnectCommon.asNumber"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="Maximum Prefix"
                  :value="detailData.saseGatewayVnConnectCommon.maximumPrefix"
                />
              </v-col>
            </v-row>

            <!-- VNコネクト情報(Act) -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold"
                  >VNコネクト情報(Act)</span
                >
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="VNコネクト番号"
                  :value="detailData.saseGatewayVnConnectAct.wnumber"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="VNコネクト名"
                  :value="detailData.saseGatewayVnConnectAct.vnConnectName"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="VNコネクト状態"
                  :value="
                    $filter.enumTo(
                      detailData.saseGatewayVnConnectAct.isVnConnectStatus,
                      'enable'
                    )
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="IF状態"
                  :value="
                    $filter.enumTo(
                      detailData.saseGatewayVnConnectAct.ifStatus,
                      'cloudVn_ifStatus'
                    )
                  "
                />
              </v-col>
            </v-row>

            <!-- VNコネクト情報(Sby) -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold"
                  >VNコネクト情報(Sby)</span
                >
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="VNコネクト番号"
                  :value="detailData.saseGatewayVnConnectSby.wnumber"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="VNコネクト名"
                  :value="detailData.saseGatewayVnConnectSby.vnConnectName"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="VNコネクト状態"
                  :value="
                    $filter.enumTo(
                      detailData.saseGatewayVnConnectSby.isVnConnectStatus,
                      'enable'
                    )
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="IF状態"
                  :value="
                    $filter.enumTo(
                      detailData.saseGatewayVnConnectSby.ifStatus,
                      'cloudVn_ifStatus'
                    )
                  "
                />
              </v-col>
            </v-row>

            <!-- ルーティング情報(Act) -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold"
                  >ルーティング情報(Act)</span
                >
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="WANアドレス"
                  :value="detailData.saseGatewayVnConnectAct.wanAddress"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="ピアIPアドレス"
                  :value="detailData.saseGatewayVnConnectAct.peerIpAddress"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="Local Preference"
                  :value="
                    $filter.enumTo(
                      detailData.saseGatewayVnConnectAct.localPreference,
                      'localPreference'
                    )
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="MED"
                  :value="
                    $filter.enumTo(
                      detailData.saseGatewayVnConnectAct.med,
                      'med'
                    )
                  "
                />
              </v-col>
            </v-row>

            <!-- ルーティング情報(Sby) -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold"
                  >ルーティング情報(Sby)</span
                >
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="WANアドレス"
                  :value="detailData.saseGatewayVnConnectSby.wanAddress"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="ピアIPアドレス"
                  :value="detailData.saseGatewayVnConnectSby.peerIpAddress"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="Local Preference"
                  :value="
                    $filter.enumTo(
                      detailData.saseGatewayVnConnectSby.localPreference,
                      'localPreference'
                    )
                  "
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="MED"
                  :value="
                    $filter.enumTo(
                      detailData.saseGatewayVnConnectSby.med,
                      'med'
                    )
                  "
                />
              </v-col>
            </v-row>

            <!-- カスタム経路集約情報 -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold"
                  >カスタム経路集約情報</span
                >
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="経路集約"
                  :value="
                    detailData.saseGatewayVnConnectCommon.routeAggregation
                  "
                />
              </v-col>
            </v-row>
            <v-row
              class="px-4"
              v-if="
                detailData.saseGatewayVnConnectCommon.routeAggregation ===
                'CUSTOM'
              "
            >
              <v-col>
                <app-label-group label="経路集約アドレス">
                  <template #value>
                    <div class="ml-3">
                      <template
                        v-for="(ip, index) in sortedRouteAggregationAddressList"
                        :key="index"
                      >
                        <div>
                          {{ ip }}
                        </div>
                      </template>
                    </div>
                  </template>
                </app-label-group>
              </v-col>
            </v-row>

            <!-- 保守連絡先情報 -->
            <v-row>
              <v-col>
                <span class="text-h6 font-weight-bold">保守連絡先情報</span>
              </v-col>
            </v-row>
            <v-row class="px-4">
              <v-col cols="4">
                <app-label-group
                  label="会社名"
                  :value="detailData.maintenance.company"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="部署名"
                  :value="detailData.maintenance.department"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="担当者名"
                  :value="detailData.maintenance.name"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="電話番号"
                  :value="detailData.maintenance.phone"
                />
              </v-col>
              <v-col cols="4">
                <app-label-group
                  label="メールアドレス"
                  :value="detailData.maintenance.email"
                />
              </v-col>
            </v-row>

            <v-row class="mt-6">
              <v-col>
                <v-tabs
                  v-model="tabValue"
                  @update:modelValue="alertClear"
                  hide-slider
                  class="border-s-sm border-t-sm border-e-sm"
                >
                  <!--運用コマンド(Act)-->
                  <v-tab text="運用コマンド(Act)" value="operationCommandAct" />
                  <!--運用コマンド(Sby)-->
                  <v-tab text="運用コマンド(Sby)" value="operationCommandSby" />
                  <!--トラフィック-->
                  <v-tab
                    text="トラフィック"
                    value="traffic"
                    v-if="contractSummary.isTrafficInfo"
                  />
                  <v-tab text="設定上限値" value="upperLimit" />
                </v-tabs>
                <v-tabs-window
                  v-model="tabValue"
                  class="border-s-sm border-b-sm border-e-sm"
                >
                  <!--運用コマンド(Act)-->
                  <v-tabs-window-item value="operationCommandAct">
                    <operation-command
                      ref="operationCommandAct"
                      lineCategory="SASE_GATEWAY"
                      :wnumber="detailData.saseGatewayVnConnectAct.wnumber"
                      :ifStatus="
                        detailData.saseGatewayVnConnectAct.ifStatus ===
                        undefined
                          ? null
                          : detailData.saseGatewayVnConnectAct.ifStatus
                      "
                      :key-id="detailData.saseGatewayPaloAltoKeyId"
                      @executed="executed"
                    ></operation-command>
                  </v-tabs-window-item>

                  <!--運用コマンド(Sby)-->
                  <v-tabs-window-item value="operationCommandSby">
                    <operation-command
                      ref="operationCommandSby"
                      lineCategory="SASE_GATEWAY"
                      :wnumber="detailData.saseGatewayVnConnectSby.wnumber"
                      :ifStatus="
                        detailData.saseGatewayVnConnectSby.ifStatus ===
                        undefined
                          ? null
                          : detailData.saseGatewayVnConnectSby.ifStatus
                      "
                      :key-id="detailData.saseGatewayPaloAltoKeyId"
                      @executed="executed"
                    ></operation-command>
                  </v-tabs-window-item>

                  <!--トラフィック-->
                  <v-tabs-window-item value="traffic">
                    <traffic
                      line-type="SASE_GATEWAY"
                      :line="{
                        wnumberMainAct:
                          detailData.saseGatewayVnConnectAct.wnumber,
                        wnumberMainSby:
                          detailData.saseGatewayVnConnectSby.wnumber,
                        saseGatewayServiceType:
                          selectedItem.saseGatewayVnConnectCommon
                            .saseGatewayServiceType,
                      }"
                    />
                  </v-tabs-window-item>

                  <!--設定上限値-->
                  <v-tabs-window-item value="upperLimit">
                    <upper-limit
                      upperLimitManageUnit="SASE_GATEWAY"
                      :wnumber="detailData.saseGatewayVnConnectAct.wnumber"
                      :sase-gateway-service-type="
                        selectedItem.saseGatewayVnConnectCommon
                          .saseGatewayServiceType
                      "
                    />
                  </v-tabs-window-item>
                </v-tabs-window>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { mapState } from "vuex";
import { defineComponent } from "vue";
import Traffic from "@/components/operation-tool/Traffic.vue";
import OperationCommand from "@/components/operation-tool/OperationCommand.vue";
import UpperLimit from "@/components/operation-tool/UpperLimit.vue";
import type { AppTableHeader, SortItem } from "@/components/AppTable.vue";
import SaseGatewaySelectType from "@/modals/saseGateway/SaseGatewaySelectType.vue";
import SaseGatewayPaloAltoEdit from "@/modals/saseGateway/paloalto/SaseGatewayPaloAltoEdit.vue";
import SaseGatewayPaloAltoDeleteConfirm from "@/modals/saseGateway/paloalto/SaseGatewayPaloAltoDeleteConfirm.vue";
import SaseGatewayVNConnectStatusModify from "@/modals/saseGateway/SaseGatewayVNConnectStatusModify.vue";
import SaseGatewayResettingList from "@/modals/saseGateway/SaseGatewayResettingList.vue";
import type {
  SaseGatewayListEntity,
  SaseGatewayPaloAltoDetailEntity,
} from "@/apis/SaseGatewayApi";
import type { SaseGatewayResetting } from "@/apis/SaseGatewayResettingApi";

export default defineComponent({
  name: "SaseGatewayList",
  components: {
    Traffic,
    OperationCommand,
    UpperLimit,
  },
  data() {
    return {
      saseGatewayTable: {
        sortBy: { key: "wnumber", order: "desc" } as SortItem,
        fields: [
          {
            key: "vpnVnCode",
            title: "接続先VPN/VNコード",
            width: "190px",
            sortable: true,
            sortByFormatted: true,
            formatter: (
              _v: string,
              _k: string,
              item: SaseGatewayListEntity
            ) => {
              if (item.saseGatewayVnConnectCommon.vpnVnCode.startsWith("D")) {
                return `${item.saseGatewayVnConnectCommon.vpnVnCode}(${item.saseGatewayVnConnectCommon.vnType})`;
              }
              return item.saseGatewayVnConnectCommon.vpnVnCode;
            },
          },
          {
            key: "vnConnectName",
            title: "VNコネクト名(Act/Sby)",
            width: "220px",
            sortable: true,
            sortByFormatted: true,
            formatter: (
              _v: string,
              _k: string,
              item: SaseGatewayListEntity
            ) => {
              return `${item.saseGatewayVnConnectAct.vnConnectName}\n${item.saseGatewayVnConnectSby.vnConnectName}`;
            },
          },
          {
            key: "wnumber",
            title: "VNコネクト番号(Act/Sby)",
            width: "170px",
            sortable: true,
            sortByFormatted: true,
            formatter: (
              _v: string,
              _k: string,
              item: SaseGatewayListEntity
            ) => {
              return `${item.saseGatewayVnConnectAct.wnumber}\n${item.saseGatewayVnConnectSby.wnumber}`;
            },
          },
          {
            key: "saseGatewayServiceType",
            title: "タイプ",
            width: "100px",
            sortable: true,
            sortByFormatted: true,
            formatter: (
              _v: string,
              _k: string,
              item: SaseGatewayListEntity
            ) => {
              return this.$filter.enumTo(
                item.saseGatewayVnConnectCommon.saseGatewayServiceType,
                "saseGatewayServiceType"
              );
            },
          },
          {
            key: "mainSite",
            title: "ロケーション",
            width: "140px",
            sortable: true,
            sortByFormatted: true,
            formatter: (
              _v: string,
              _k: string,
              item: SaseGatewayListEntity
            ) => {
              return this.$filter.enumTo(
                item.saseGatewayVnConnectCommon.location,
                "location"
              );
            },
          },
          {
            key: "isVnConnectStatus",
            width: "150px",
            title: "VNコネクト状態",
            sortable: true,
            sortByFormatted: true,
            formatter: (
              _v: string,
              _k: string,
              item: SaseGatewayListEntity
            ) => {
              return this.$filter.enumTo(
                item.saseGatewayVnConnectAct.isVnConnectStatus,
                "enable"
              );
            },
          },
        ] as AppTableHeader<SaseGatewayListEntity>[],
        items: [] as SaseGatewayListEntity[],
      },
      tabValue: "operationCommandAct" as
        | "operationCommandSby"
        | "traffic"
        | "upperLimit",
      selectedItem: null as null | SaseGatewayListEntity,
      detailData: {} as SaseGatewayPaloAltoDetailEntity,
      isLoaded: false,
      isDetailLoaded: false,
      saseGatewayKeyId: "",

      saseGatewayResettingResult: {} as SaseGatewayResetting,

      // SASEゲートウェイ残り契約数
      saseGatewayRemainingContracts: 0,
      // SASEゲートウェイ残り帯域値(Mbps)
      saseGatewayRemainingBandwidth: 0,
      // SASEゲートウェイVNコネクト帯域値上限(Mbps)
      saseGatewayBandwidthUpperLimit: 0,
    };
  },
  async mounted() {
    await this.load();

    this.isLoaded = true;
  },
  computed: {
    ...mapState("user", {
      contractInfo: "contractInfo",
      contractSummary: "contractSummary",
    }),

    /** VNコネクトの有効/無効状態（ActとSbyは同一のためActのみ判定） */
    isVnConnectEnabled(): boolean {
      return (
        this.selectedItem?.saseGatewayVnConnectAct.isVnConnectStatus ?? false
      );
    },

    /** 経路集約アドレス（数値昇順ソート済み） */
    sortedRouteAggregationAddressList(): string[] {
      const list =
        this.detailData.saseGatewayVnConnectCommon
          ?.routeAggregationAddressList ?? [];
      return list.sortIpAddress();
    },
  },
  methods: {
    /**
     * SASEゲートウェイ一覧を取得
     */
    async load() {
      const data = await this.$api.saseGateway.getSaseGatewayList();
      this.saseGatewayTable.items = data.saseGatewayList;
      this.saseGatewayKeyId = data.saseGatewayKeyId;

      // VNコネクト設定未完了一覧を取得
      this.saseGatewayResettingResult =
        await this.$api.saseGatewayResetting.getSaseGatewayResetting();

      // 上限値を取得し、制御用のため「ゲートウェイ選択」と「VNコネクト設定」モーダルにて使用
      await this.getUpperLimit();

      // 契約詳細を開いている場合に再読み込み
      if (this.selectedItem) {
        const selected = this.saseGatewayTable.items.find(
          (e) =>
            e.saseGatewayVnConnectAct.wnumber ===
            this.selectedItem!.saseGatewayVnConnectAct.wnumber
        );
        if (selected) {
          await this.selectRow(selected);
        } else {
          this.selectedItem = null;
          this.isDetailLoaded = false;
        }
      }
    },
    async getUpperLimit() {
      // 上限値を取得し「SASEゲートウェイ回線契約数」「SASEゲートウェイ接続先合計帯域値」「VNコネクト帯域値」の項目名に一致する値を返すようにする
      const result = await this.$api.upperLimit.getUpperLimitLine({
        upperLimitLineManageUnit: "SASE_GATEWAY",
        saseGatewayServiceType: "PALOALTO",
      });

      result.saseGateway!.upperLimitList.forEach((item) => {
        if (item.upperLimitItemName === "SASEゲートウェイ回線契約数") {
          this.saseGatewayRemainingContracts = item.upperLimit - item.current!;
        } else if (
          item.upperLimitItemName === "SASEゲートウェイ接続先合計帯域値"
        ) {
          this.saseGatewayRemainingBandwidth = item.upperLimit - item.current!;
        } else if (item.upperLimitItemName === "VNコネクト帯域値") {
          this.saseGatewayBandwidthUpperLimit = item.upperLimit;
        }
      });
    },
    /**
     * 行を選択
     * @param item 選択した行データ
     */
    async selectRow(item: SaseGatewayListEntity) {
      this.selectedItem = item;
      this.isDetailLoaded = false;

      // 詳細情報を取得
      const detail = await this.$api.saseGateway.getPaloAltoDetail(
        item.saseGatewayVnConnectAct.wnumber
      );
      this.detailData = detail;
      this.isDetailLoaded = true;
    },

    /**
     * 選択した行の背景色を変更する処理
     * @param item 行データ
     */
    rowHighlight(item: SaseGatewayListEntity): string[] | undefined {
      if (
        item.saseGatewayVnConnectAct.wnumber ===
        this.selectedItem?.saseGatewayVnConnectAct.wnumber
      ) {
        return ["table-success"];
      }
      return ["clickable"];
    },

    /** エラーメッセージを初期化する */
    async alertClear() {
      if (this.$refs.operationCommandAct) {
        (
          this.$refs.operationCommandAct as InstanceType<
            typeof OperationCommand
          >
        ).alertClear();
      } else if (this.$refs.operationCommandSby) {
        (
          this.$refs.operationCommandSby as InstanceType<
            typeof OperationCommand
          >
        ).alertClear();
      }
    },

    /**
     * コマンド実行後の処理
     * IF設定反映の場合、一覧画面へ戻る
     * @param eventType 実行されたコマンドの種類
     */
    async executed(eventType: string) {
      if (eventType === "IF_STATE") {
        await this.load();
      }
    },

    /**
     * セキュリティリンクを新しいタブで開く
     */
    openSecurityLink() {
      // 現在選択中のVNコネクト情報のタイプごとにURLを分岐させる
      const serviceType =
        this.selectedItem!.saseGatewayVnConnectCommon.saseGatewayServiceType;

      switch (serviceType) {
        case "PALOALTO":
          window.open("https://apps.paloaltonetworks.com/hub", "_blank");
          break;
        default:
          break;
      }
    },

    /**
     * 契約追加モーダルを表示
     */
    async showRegister() {
      await this.$modal.show(SaseGatewaySelectType, {
        paloAltoItems: this.saseGatewayTable.items.filter(
          (v) =>
            v.saseGatewayVnConnectCommon.saseGatewayServiceType === "PALOALTO"
        ),
        saseGatewayKeyId: this.saseGatewayKeyId,
        saseGatewayRemainingContracts: this.saseGatewayRemainingContracts,
        saseGatewayRemainingBandwidth: this.saseGatewayRemainingBandwidth,
        saseGatewayBandwidthUpperLimit: this.saseGatewayBandwidthUpperLimit,
      });
      // モーダルが閉じられたらデータを再読み込み
      await this.load();
    },

    /**
     * VNコネクト設定未完了一覧モーダルを表示
     */
    async showSaseGatewayResetting() {
      await this.$modal.show(SaseGatewayResettingList, {
        saseGatewayResetting: this.saseGatewayResettingResult,
      });
      // モーダルが閉じられたらデータを再読み込み
      await this.load();
    },

    /**
     * 契約変更モーダルを表示
     */
    async showEdit() {
      await this.$modal.show(SaseGatewayPaloAltoEdit, {
        saseGatewayPaloAltoDetail: this.detailData,

        paloAltoItems: this.saseGatewayTable.items.filter(
          (v) =>
            v.saseGatewayVnConnectCommon.saseGatewayServiceType === "PALOALTO"
        ),
        saseGatewayRemainingBandwidth: this.saseGatewayRemainingBandwidth,
        saseGatewayBandwidthUpperLimit: this.saseGatewayBandwidthUpperLimit,
      });
      // モーダルが閉じられたらデータを再読み込み
      await this.load();
    },

    /**
     * VNコネクト有効/無効確認モーダルを表示
     * @param status true: 有効化, false: 無効化
     */
    async modifyStatus(status: boolean) {
      // ActとSbyのwnumberを配列にまとめる
      const wnumbers = [
        this.detailData.saseGatewayVnConnectAct.wnumber,
        this.detailData.saseGatewayVnConnectSby.wnumber,
      ];

      await this.$modal.show(SaseGatewayVNConnectStatusModify, {
        wnumbers,
        vnConnectStatus: status ? "有効" : "無効",
      });

      // API呼び出し
      if (status) {
        await this.$api.saseGateway.enablePaloAlto({
          saseGatewayVnConnectList: wnumbers,
          saseGatewayPaloAltoKeyId: this.detailData.saseGatewayPaloAltoKeyId,
        });
      } else {
        await this.$api.saseGateway.disablePaloAlto({
          saseGatewayVnConnectList: wnumbers,
          saseGatewayPaloAltoKeyId: this.detailData.saseGatewayPaloAltoKeyId,
        });
      }

      // モーダルが閉じられたらデータを再読み込み
      await this.load();
    },

    /**
     * 解約確認モーダルを表示して削除処理を実行
     */
    async showDeleteConfirm() {
      // 削除確認モーダルの表示
      await this.$modal.show(SaseGatewayPaloAltoDeleteConfirm, {
        detailData: this.detailData,
        saseGatewayServiceType:
          this.selectedItem!.saseGatewayVnConnectCommon.saseGatewayServiceType,
      });
      // 削除処理
      await this.$api.saseGateway.deletePaloAlto({
        saseGatewayVnConnectList: this.detailData.saseGatewayVnConnectSby
          ?.wnumber
          ? [
              this.detailData.saseGatewayVnConnectAct.wnumber,
              this.detailData.saseGatewayVnConnectSby.wnumber,
            ]
          : [this.detailData.saseGatewayVnConnectAct.wnumber],
        saseGatewayPaloAltoKeyId: this.detailData.saseGatewayPaloAltoKeyId,
      });
      // 一覧を再読み込み
      await this.load();
    },
    // ソート対応のため、slotではなくformatterで改行コードを使用。そのため、改行コードを含むセルに対してスタイルを適用する。
    tdClass(field: AppTableHeader<unknown>): string[] | undefined {
      if (field.key === "vnConnectName" || field.key === "wnumber") {
        return ["text-pre-wrap"];
      }
      return undefined;
    },
  },
});
</script>
